<template>
    <div class="address-fields">
        <div class="address-content">
            <div class="form-row half">
                <div class="form-field form-field-firstName">
                    <!-- <label for="firstName">First name</label> -->
                    <input type="text" id="firstName" class="input-firstName" placeholder="First Name" v-model="customer.firstName" name="firstName" v-on:blur="validateFirstName">
                    <span v-for="error in errors.firstName" :key="error">* {{error}}</span>
                </div>
                <div class="form-field form-field-lastName">
                    <!-- label for="lastName">Last name</label> -->
                    <input type="text" id="lastName" placeholder="Last Name" class="input-lastName" v-model="customer.lastName" name="lastName" v-on:blur="validateLastName">
                    <span v-for="error in errors.lastName" :key="error">* {{error}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-field form-field-address">
                    <!-- <label for="address">Address</label> -->
                    <input type="text" id="address" placeholder="Street" class="input-address" name="address" v-model="customer.address" v-on:blur="validateAddress">
                    <span v-for="error in errors.address" :key="error">* {{error}}</span>
                </div>
            </div>
            <div class="form-row half">
                <div class="form-field form-field-postcode">
                    <!-- <label for="postcode">Postal code</label> -->
                    <input type="text" id="postcode" placeholder="Postal Code" class="input-postcode" name="postcode" v-model="customer.postCode" v-on:blur="validatePostcode">
                    <span v-for="error in errors.postCode" :key="error">* {{error}}</span>
                </div>
                <div class="form-field form-field-city">
                    <!-- <label for="city">City</label> -->
                    <input type="text" id="city" placeholder="City" class="input-city" name="city"  v-model="customer.city" v-on:blur="validateCity">
                    <span v-for="error in errors.city" :key="error">* {{error}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-field form-field-country">
                    <country-select @countryChanged="countryChanged" v-on:blur="validateCountry" />
                    <span v-for="error in errors.country" :key="error">* {{error}}</span>
                </div>
            </div>
            <div class="form-row">
                <div class="form-field form-field-promotioncode">
                    <!-- <label for="promotion-code">Promotion Code</label> -->
                    <input type="text" id="promotioncode" placeholder="Promotion Code" class="input-promotioncode" name="promotioncode" v-model="promotionCode" v-on:blur="validatePromotionCode">
                    <span v-for="error in errors.promotionCode" :key="error">* {{error}}</span>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import countrySelect from '@/components/checkout/CountrySelect'
export default {
    name: "addressFields",
    data() {
        return {
            customer: {},
            promotionCode: '',
            errors: {
                firstName:[],
                lastName:[],
                address:[],
                postCode:[],
                city:[],
                country:[],
            },
        }
    },
    mounted() {
        this.customer = this.checkoutCustomerModel;
    },
    components: {
        countrySelect,
       
    },
    methods: {
        validateFirstName() {
            if(this.customer.firstName === "")
            this.addError("firstName", "First name is missing"); 
            else{
                this.updateStore("customer", this.customer); 
                this.RemoveError("firstName");
            }
        },
        validateLastName() {
            if(this.customer.lastName === "")
                this.addError("lastName", "Last name is missing"); 
            else{
                this.updateStore("customer", this.customer); 
                this.RemoveError("firstName");
            }
        },
        validateAddress() {
        if(this.customer.address === "")
            this.addError("address", "address is missing"); 
            else{
            this.updateStore("customer", this.customer); 
            this.RemoveError("address");
            }
        },
        validatePostcode() {
        if(this.customer.postCode === "")
            this.addError("postCode", "postCode is missing"); 
            else {
                this.updateStore("customer", this.customer); 
                this.RemoveError("postCode");
            }
        },
        validateCity() {
            if(this.customer.postCode === "")
            this.addError("city", "city is missing"); 
            else{
                this.updateStore("customer", this.customer);
                this.RemoveError("postCode");
            }
        },
        validateCountry() {
            var shipping = this.$store.getters["CHECKOUT/GET_CHECKOUT_MODEL"]
            if(shipping === "")
                this.addError("country", "country is missing"); 
            else{
                this.updateStore("customer", this.customer);
                this.RemoveError("country");
            }
        },
        validatePromotionCode() {
            if(this.promotionCode !== "")
            {
                this.updateStore("promotionCode", this.promotionCode);
                this.RemoveError("promotionCode");
            }
        },
        updateStore(property, value) {
            this.$store.dispatch("CHECKOUT/UPDATE_CHECKOUT_MODEL_FIELD", { property: property, value: value });
        },
        countryChanged (value) {
            this.customer.country = value
            this.$store.dispatch("CHECKOUT/UPDATE_CHECKOUT_MODEL_FIELD", { property: "customer", value: this.customer });
        },
        addError(property, error) {
          var listOfErrors = this.errors[property];
          if(listOfErrors.indexOf(error) === -1)
          {
              listOfErrors.push(error);
          }
        },
         RemoveError(property) {
            this.errors[property] = [];
        }
    },
    computed: {
        checkoutCustomerModel() {
          return this.$store.getters["CHECKOUT/GET_CHECKOUT_MODEL"].customer;
        },
       
    },
}
</script>

<style lang="postcss" scoped>
  input {
    background-color: white;
    padding: 10px;
    height: 20px;
    margin: 5px 0;  
    width: auto;
    -webkit-appearance: none;
    border-radius: 0;
  }
  .address-fields {  
    display: flex;
    width: 100%;
    order: 2;
  }
  .address-content {
    width: 100%;
  }
    .form-field-firstName,
  .form-field-postcode {
      width: 40%;
      padding-right: 0.3em;

  }
  .half {
      padding-bottom: 0;
  }
  .form-field-firstName,
  .form-field-lastName,
  .form-field-postcode,
  .form-field-city,
  .form-field-promotioncode {
      padding-bottom: .8em;
  }  
  
    .form-field-country {
        padding-top: .2em;
    }

  .form-field-country,
  .form-field-lastName,
  .form-field-address,
  .form-field-city {
    width: 100%;
  }
  label { font-size: 0.9em; margin: 0;}
  
@media only screen and (max-width: 768px) {

   h3 { text-align: center; font-size: 1.8em; width: 100%;}
   input {padding: 18px 6px 14px 6px;}

   .address-fields {
       width: 100%;
   }
    .form-field-firstName,
    .form-field-postcode {
        width: 100%;
        padding-right: 0;
    }
    .form-row {
        display: flex;
        flex-direction: column;
    }
 
  
}

</style>